import { useEffect, useState } from "react";
import { LuLibrary } from "react-icons/lu";

import Preloader from "../../../app-components/preloader/Preloader";
import apiClient from "../../../api-services/ApiClient";
import { ToastContainer } from "react-toastify";
import { ExcelFile, ExcelSheet, ExcelColumn } from "react-xlsx-wrapper";
import { RiFileExcel2Line } from "react-icons/ri";

const VesselReport = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportType, setReportType] = useState("");

  const [defectsOverTime, setDefectsOverTime] = useState<any[]>([]);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // effect for get users list
  useEffect(() => {
    const params = {
      OrderBy: "Descending",
      PageSize: pageSize,
      StartDate: startDate,
      EndDate: endDate,
    };

    switch (reportType) {
      case "DefectsOverTime":
        getDefectsOverTime(params);
        break;
    }
  }, [pageSize, startDate, endDate, reportType]);

  const getDefectsOverTime = async (params: any) => {
    try {
      setLoading(true);
      const res: any = await apiClient.get(
        "VesselDefectReport/DefectsOverTime",
        { params }
      );
      if (res && res.data) {
        const flattened = res.data.data.flatMap((vessel: any) =>
          vessel.vesselsDefectReports.map((report: any) => ({
            vesselId: vessel.vesselId,
            vesselName: vessel.vesselName,
            ...report,
          }))
        );

        console.log(flattened);

        setDefectsOverTime(flattened);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* page lead */}
      <section className="flex justify-between items-center bg-gradient-to-r from-secondaryBlue to-primaryBlue shadow-md border-b border-gray-200">
        <div className="xl:container xl:mx-auto md:px-4 py-4 pb-24 flex justify-between items-center">
          <h4 className="lg:text-[16px] text-white font-medium">
            Vessel Defect Report
          </h4>

          {/*page actions */}
          <div className="flex gap-2">
            {reportType === "DefectsOverTime" && (
              <ExcelFile
                filename={"User-Activity-Data-" + new Date()}
                element={
                  <button className="border-white border-2 flex gap-2 p-2 px-4 rounded-md text-sm items-center text-white font-medium hover:shadow-xl shadow">
                    <RiFileExcel2Line />
                    <span className="text-xs">Export Table</span>
                  </button>
                }
              >
                <ExcelSheet data={defectsOverTime} name="User Activity Report">
                  {/* <ExcelColumn label="ID" value="vesselId" /> */}
                  <ExcelColumn label="Vessel" value="vesselName" />
                  <ExcelColumn label="Report Year" value="year" />
                  <ExcelColumn label="Report Month" value="month" />
                  <ExcelColumn label="Defects" value="totalDefects" />
                </ExcelSheet>
              </ExcelFile>
            )}
          </div>
        </div>
      </section>

      {/* page content */}
      <section className="pt-5 mx-auto md:px-4 xl:container relative top-[-100px] xl:top-[-100px]">
        <div className="rounded-lg bg-white shadow-sm flex p-10 gap-3">
          <select
            className="p-2 py-5 text-xs border border-gray-300 hover:border-blue-400 rounded-lg w-full font-semibold"
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="">Report Title</option>
            {/* <option value="SingleVesselDefectOverTime">Single Vessel Defect Over Time</option>
            <option value="MultipleVesselDefectOverTime">Endpoint Summary</option> */}
            <option value="DefectsOverTime">Defects Over Time</option>
          </select>

          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            id="entries"
            className="p-2 py-1.5 text-xs border border-gray-300 hover:border-blue-400 rounded-lg"
          >
            <option value="10">Show 10 entries</option>
            <option value="25">Show 25 entries</option>
            <option value="50">Show 50 entries</option>
            <option value="100">Show 100 entries</option>
            <option value="250">Show 250 entries</option>
            <option value="500">Show 500 entries</option>
            <option value="1000">Show 1000 entries</option>
          </select>

          <input
            className="p-2 py-5 text-xs border border-gray-300 hover:border-blue-400 rounded-lg w-full font-semibold"
            type="date"
            onChange={(e) => setStartDate(e.target.value)}
          />

          <input
            className="p-2 py-5 text-xs border border-gray-300 hover:border-blue-400 rounded-lg w-full font-semibold"
            type="date"
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
      </section>

      <section className="pt-5 mx-auto md:px-4 xl:container relative top-[-100px] xl:top-[-100px]">
        {reportType === "DefectsOverTime" && (
          <div className="rounded-lg pb-6 bg-white shadow-sm border">
            <div className="overflow-x-auto mb-5 overflow-y-auto">
              <table className="min-w-full bg-white mb-4">
                <thead>
                  <tr className="w-full bg-slate-100 text-slate-600 capitalize text-[12px] leading-normal border-b shadow-sm">
                    <th className="py-3 px-3 text-left font-medium">SN</th>
                    <th className="py-3 px-3 text-left font-medium">
                      Vessel ID
                    </th>
                    <th className="py-3 px-3 text-left font-medium">
                      Report Year
                    </th>
                    <th className="py-3 px-3 text-left font-medium">
                      Report Month
                    </th>
                    <th className="py-3 px-3 text-left font-medium">
                      Total Defect
                    </th>
                  </tr>
                </thead>

                {!!defectsOverTime?.length && (
                  <tbody>
                    {defectsOverTime?.map((data: any, i: number) => {
                      return (
                        <tr
                          key={data.vesselId}
                          className={`border-b border-[#F2F1F1] hover:bg-gray-100 font-normal text-xs`}
                        >
                          <td className="py-3 px-3 text-left align-top">
                            {i + 1}
                          </td>

                          <td className="py-3 px-3 text-left align-top">
                            {data?.vesselName}
                          </td>

                          <td className="py-3 px-3 text-left align-top">
                            {data?.year}
                          </td>

                          <td className="py-3 px-3 text-left align-top">
                            {months[data?.month]}
                          </td>

                          <td className="py-3 px-3 text-left break-words max-w-[250px] align-top cursor-pointer">
                            {data?.totalDefects}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                )}
              </table>

              {!defectsOverTime?.length && (
                <div className="text-center p-5 text-sm text-gray-500 ">
                  <LuLibrary className="text-[50px] w-full" />
                  <p> No record found</p>
                </div>
              )}
            </div>
          </div>
        )}
      </section>

      <ToastContainer position="bottom-left" hideProgressBar />
      <Preloader loading={loading} />
    </>
  );
};

export default VesselReport;
